import ReportPlaceholder from '@assets/images/icons/octopus/report-placeholder.svg?react'
import type React from 'react'
import { useState } from 'react'

interface Props {
  faviconUrl?: string | null
  className?: string
}

// A report project has no canvas snapshot to screenshot, so it is shown with
// the crawled site's favicon. A favicon is a link to someone else's server: it
// can 404 or refuse us long after the crawl saw it, and a broken image icon
// looks worse than no logo.
export const ReportFavicon: React.FC<Props> = ({
  faviconUrl = null,
  className = '',
}) => {
  const [failed, setFailed] = useState(false)

  if (!faviconUrl || failed) {
    return <ReportPlaceholder className={className} />
  }

  return (
    <img
      alt=""
      className={className}
      src={faviconUrl}
      onError={() => setFailed(true)}
    />
  )
}
